export default {
  qmulusMaterialSelected: 'You selected a Qmulus material. Its analysis values will be saved, but not the material name.',
  pt9800MaterialSelected: 'You selected a PT9800 material. Its analysis cannot be changed.',
};
